import { usePermissions } from "@/hooks/usePermissions";

// Who may administer access roles (create/edit/delete roles and assign them to
// staff): the restaurant's managers (primary or secondary), franchise owners,
// admins and support. That set is exactly the full-access set (see
// usePermissions); permission-granted staff never see the role-administration
// UI, so nobody can delegate themselves more access.
export function useCanAdministerRoles(): boolean {
  return usePermissions().isFullAccess;
}
